<template>
  <i
    aria-hidden="true"
    class="s-icon"
    :class="iconClasses"
    @click="$emit('click', $event)"
  />
</template>

<script setup lang="ts">
import { type DesignSystemIcons } from "design-system/types";
import { computed } from "vue";

const props = defineProps<{
  icon: DesignSystemIcons;
  iconClass?: string;
}>();

defineEmits(["click"]);

const iconClasses = computed(
  () => `s-icon-${props.icon}${props.iconClass ? ` ${props.iconClass}` : ""}`
);
</script>

<style lang="scss" scoped>
.s-icon {
  vertical-align: middle;
  line-height: 1;
  user-select: none;
  cursor: inherit;
}
</style>
